import { mode } from "@chakra-ui/theme-tools";

export const buttonStyles = {
  components: {
    Button: {
      defaultProps: {
        size: "xl",
      },
      sizes: {
        xl: {
          h: "70px",
        },
      },
      baseStyle: {
        w: "100%",
        borderRadius: "xl",
      },
      variants: {
        primary: (props) => ({
          color: "white",
          bg: "blue.light",
          border: "none",
          _disabled: {
            bg: "blue.dark",
          },
          _hover: {
            bg: "blue.dark",
            color: "white",
            _disabled: {
              bg: "blue.dark",
            },
          },
        }),
        outline: (props) => ({
          color: "red.light",
          bg: "transparent",
          border: "2px solid",
          borderColor: { bg: mode("red.light", "red.dark")(props) },
          _hover: {
            bg: mode("red.light", "red.dark")(props),
            borderColor: mode("red.light", "red.dark")(props),
            color: "white",
          },
          _focus: { bg: mode("blue.50", "transparent")(props) },
          _active: { bg: mode("blue.50", "transparent")(props) },
        }),
        cancel: (props) => ({
          color: "white",
          bg: "red.light",
          border: "none",
          _hover: {
            bg: "red.dark",
            color: "white",
          },
        }),
        fab: (props) => ({
          position: "absolute",
          bottom: 5,
          right: 5,
          w: "70px",
          h: "70px",
          borderRadius: "full",
          color: "white",
          bg: "blue.light",
          border: "none",
          _hover: {
            bg: "blue.dark",
          },
        }),
      },
    },
  },
};
